
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { DepartmentViewModel, ExecutionResult, ILegacyLookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * DepartmentLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class DepartmentLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<DepartmentViewModel[]>> {
        return this.$apiService.sendAuth("IDepartmentLookupService/Lookup", pCriteria);
    }
}
